import {
  Button,
  Form,
  Input,
  Modal,
  Result,
  Select,
  Spin,
  Typography,
} from "antd";
import Header from "../components/Header";
import axios from "axios";
import { CustomerResponse } from "../models/customer-response";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { BASE_URL } from "../common/config";
import { useParams } from "react-router-dom";

const { Option } = Select;

interface CustomerDto {
  gender: string;
  firstName: string;
  lastName: string;
  msisdn: string;
  alternateMsisdn: string;
  idNumber: string;
  physicalAddress: string;
  occupation: string;
  sourceOfFunds: string;
  businessName: string;
  employer: string;
  businessAddress: string;
}

function KycPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { msisdn } = useParams();

  const history = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showFailedModal = () => {
    setIsFailedModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    history("/");
  };

  const [form] = Form.useForm();

  if (!msisdn) {
    return <Spin />;
  }

  console.log(msisdn);

  const onFinish = async (values: any) => {
    setIsLoading(true);
    console.log("Received values of form: ", values);
    const phone = values.phone;
    const alternateMsisdn = `260${phone}`;

    const createCustomer: CustomerDto = {
      firstName: values.firstName,
      lastName: values.lastName,
      msisdn: msisdn,
      alternateMsisdn: alternateMsisdn,
      idNumber: values.idNumber,
      physicalAddress: values.physicalAddress,
      occupation: values.occupation,
      sourceOfFunds: values.sourceOfFunds,
      businessName: values.businessName,
      employer: values.employer,
      businessAddress: values.businessAddress,
      gender: values.gender,
    };

    try {
      const response = await axios.post<CustomerResponse>(
        `${BASE_URL}/customers`,
        createCustomer
      );

      if (response.data) {
        showModal();
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      showFailedModal();
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />

      <div className="container mx-auto flex align-middle justify-center content-center py-10">
        <div className="col ">
          <span className="box-decoration-clone  px-2 font-serif letter-spacing: 0.025em">
            KYC VERIFICATION
          </span>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Form
          form={form}
          name="kyc_form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          className="lg:w-1/4"
        >
          <Typography>
            <pre>Phone Number: {msisdn}</pre>
          </Typography>
          <Form.Item
            name="firstName"
            rules={[
              {
                required: true,
                message: "Please input your First Name!",
              },
            ]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
          <Form.Item
            name="lastName"
            rules={[
              {
                required: true,
                message: "Please input your Last Name!",
              },
            ]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>

          <Form.Item name="phone">
            <Input
              addonBefore={260}
              style={{ width: "100%" }}
              maxLength={9}
              minLength={9}
              placeholder="Altenate Phone Number"
            />
          </Form.Item>

          <Form.Item
            name="gender"
            rules={[{ required: true, message: "Please select gender!" }]}
          >
            <Select placeholder="select your gender">
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="idNumber"
            rules={[
              {
                required: true,
                message: "Please input your ID Number!",
              },
            ]}
          >
            <Input placeholder="Id Number" />
          </Form.Item>
          <Form.Item
            name="physicalAddress"
            rules={[
              {
                required: true,
                message: "Please input your physical address!",
              },
            ]}
          >
            <Input placeholder="Physical Address" />
          </Form.Item>
          <Form.Item
            name="occupation"
            rules={[
              {
                required: true,
                message: "Please input your occupation!",
              },
            ]}
          >
            <Input placeholder="Occupation" />
          </Form.Item>
          <Form.Item
            name="sourceOfFunds"
            rules={[
              {
                required: true,
                message: "Please input your source of funds!",
              },
            ]}
          >
            <Input placeholder="Source of Funds" />
          </Form.Item>
          <Form.Item
            name="businessName"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input placeholder="Business Name" />
          </Form.Item>
          <Form.Item
            name="employer"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input placeholder="Employer" />
          </Form.Item>
          <Form.Item
            name="businessAddress"
            rules={[
              {
                required: true,
                message: "Please input your source of funds!",
              },
            ]}
          >
            <Input placeholder="Business Address" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button  bg-blue-500"
              style={{ width: "100%" }}
              loading={isLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
      <Modal open={isModalOpen} onCancel={handleCancel} footer={null}>
        <Result
          status="success"
          title="Thank you for your submission!"
          subTitle="You can continue saving and earning with Patumba"
        />
      </Modal>

      <Modal open={isFailedModalOpen} onCancel={handleCancel} footer={null}>
        <Result
          status="500"
          title="500"
          subTitle="Sorry, something went wrong."
        />
      </Modal>
    </>
  );
}

export default KycPage;
